import { createTheme } from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";

const theme = createTheme(
    {
        palette: {
            primary: {
                light: "#455b7c",
                main: "#17325C",
                dark: "#102340",
                contrastText: "#fff",
                mainGradient:
                    "linear-gradient(0.25turn, #3f87a6, #ebf8e1, #f69d3c)",
                label: "#999"
            },
            secondary: {
                light: "#35baf6",
                main: "#03A9F4",
                dark: "#0276aa",
                contrastText: "#fff",
            },
            primaryDark: {
                main: "#272D3B",
            },
        },
        spacing: (factor) => `${0.25 * factor}rem`,
    },
    ptBR
);

export default theme;
